:host {
  --aha-color-dot--size: 1em;
  --aha-color-dot--opacity: 0.4;
  --aha-color-dot--background: var(--aha-color-dot--color);
  --aha-color-dot--foreground: var(--aha-color-dot--color);
  --aha-color-dot--pulse-style: solid;

  vertical-align: middle;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: var(--aha-color-dot--size);
  height: var(--aha-color-dot--size);
  border-radius: 50%;
  position: relative;
}
:host(:not([color])),
:host([color='gray']) {
  --aha-color-dot--color: var(--aha-gray-700);
}
:host([color='purple']) {
  --aha-color-dot--color: var(--aha-purple-400);
}
:host([color='blue']) {
  --aha-color-dot--color: var(--aha-blue-500);
}
:host([color='teal']) {
  --aha-color-dot--color: var(--aha-teal-600);
}
:host([color='green']) {
  --aha-color-dot--color: var(--aha-green-700);
}
:host([color='light-green']) {
  --aha-color-dot--color: var(--aha-green-500);
}
:host([color='yellow']) {
  --aha-color-dot--color: var(--aha-yellow-700);
}
:host([color='orange']) {
  --aha-color-dot--color: var(--aha-orange-700);
}
:host([color='red']) {
  --aha-color-dot--color: var(--aha-red-700);
}
:host([color='pink']) {
  --aha-color-dot--color: var(--aha-pink-400);
}

#dot {
  border-radius: inherit;
  width: inherit;
  height: inherit;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--aha-color-dot--background);
  opacity: var(--aha-color-dot--opacity);
}

:host([pulse])::before {
  position: absolute;
  content: '';
  height: inherit;
  width: inherit;
  border-radius: inherit;
  border: 0.25em var(--aha-color-dot--pulse-style) var(--aha-color-dot--color);
  animation-name: ring;
  animation-duration: 1.6s;
  animation-iteration-count: infinite;
}
:host::after {
  content: '';
  height: calc(var(--aha-color-dot--size) / 3);
  width: calc(var(--aha-color-dot--size) / 3);
  border-radius: inherit;
  background: var(--aha-color-dot--foreground);
  position: relative;
  z-index: 1;
}

@keyframes ring {
  0% {
    transform: rotate(180deg) scale(0.25);
    opacity: 1;
  }
  100% {
    transform: rotate(180deg) scale(1.35);
    opacity: 0;
  }
}
